module.exports = __webpack_public_path__ + "static/media/thiago_almada.11bc0fad.jpg";